import { render } from "./CryptoStatistic.vue?vue&type=template&id=942cc12c"
import script from "./CryptoStatistic.vue?vue&type=script&lang=js"
export * from "./CryptoStatistic.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__